<template>
    <div>
        <h4 class="text-primary">Parametres des interventions</h4>
        <hr>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link" :class="{ 'active': activeTab === 'garages' }" id="nav-home-tab"
                    @click="activeTab = 'garages'" data-toggle="tab" data-target="#nav-home" type="button" role="tab"
                    aria-controls="nav-home" aria-selected="true">Garages</button>
                <button class="nav-link" :class="{ 'active': activeTab === 'services' }" id="nav-profile-tab"
                    @click="activeTab = 'services'" data-toggle="tab" data-target="#nav-profile" type="button"
                    role="tab" aria-controls="nav-profile" aria-selected="false">Services</button>
                <button class="nav-link" :class="{ 'active': activeTab === 'fournisseurs' }" id="nav-contact-tab"
                    @click="activeTab = 'fournisseurs'" data-toggle="tab" data-target="#nav-contact" type="button"
                    role="tab" aria-controls="nav-contact" aria-selected="false">Fournisseurs</button>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'garages' }" id="nav-home" role="tabpanel"
                aria-labelledby="nav-home-tab">
                <div class="pt-3">
                    <IndexGarage v-if="activeTab === 'garages'" />
                </div>
            </div>
            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'services' }" id="nav-profile"
                role="tabpanel" aria-labelledby="nav-profile-tab">
                <div class="pt-3">
                    <IndexService v-if="activeTab === 'services'" />
                </div>
            </div>
            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'fournisseurs' }" id="nav-contact"
                role="tabpanel" aria-labelledby="nav-contact-tab">
                <div class="pt-3">
                    <IndexFournisseur v-if="activeTab === 'fournisseurs'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import IndexFournisseur from "./fournisseurs/IndexFournisseur.vue";
import IndexGarage from "./garages/IndexGarage.vue";
import IndexService from "./services/IndexService.vue";

export default defineComponent({
    components: { IndexFournisseur, IndexGarage, IndexService },
    data() {
        return {
            activeTab: 'garages'
        };
    },
    mounted() {
        // Vérifier si une URL contient un hash qui pourrait indiquer un onglet spécifique
        const hash = window.location.hash;
        if (hash) {
            if (hash.includes('services')) {
                this.activeTab = 'services';
                setTimeout(() => {
                    document.getElementById('nav-profile-tab').click();
                }, 100);
            } else if (hash.includes('fournisseurs')) {
                this.activeTab = 'fournisseurs';
                setTimeout(() => {
                    document.getElementById('nav-contact-tab').click();
                }, 100);
            }
        }
    }
});
</script>

<style scoped>
.tab-pane {
    min-height: 300px;
}
</style>